import { create } from 'zustand';
import type { SitemapResult } from './types';

export type Tab =
  | 'tree'
  | 'table'
  | 'performance'
  | 'warnings'
  | 'external'
  | 'images'
  | 'excluded';

// テーブルのフィルタは「全て / ステータス系 / 要確認系」の 3 階層構造を持つ。
// WarningsSummary（上の "alt 欠 38" などのチップ）はこの tableFilter を書き換えて
// テーブルタブに切り替える。これにより上の "発見" 帯と下の "テーブル" が連動する
export type StatusBucket = '2xx' | '3xx' | '4xx' | '5xx' | 'error';
export type WarningKind =
  | 'all'
  | 'altMissing'
  | 'h1Abnormal'
  | 'canonicalBroken'
  | 'titleMissing';
export type TableFilter =
  | { kind: 'all' }
  | { kind: 'status'; status: StatusBucket }
  | { kind: 'warning'; warning: WarningKind };

export const TABLE_FILTER_ALL: TableFilter = { kind: 'all' };

interface AppState {
  data: SitemapResult | null;
  fileName: string | null;
  loadError: string | null;
  // CommandBuilder 画面の表示フラグ。DropZone / データ表示画面のどちらからもアクセス可能
  showCommandBuilder: boolean;
  // 現在のタブ。WarningsSummary などからの遷移を受けるため store に持つ
  activeTab: Tab;
  // テーブルのフィルタ状態。WarningsSummary と TableView で共有
  tableFilter: TableFilter;
  setData: (data: SitemapResult, fileName: string) => void;
  setError: (msg: string) => void;
  clear: () => void;
  openCommandBuilder: () => void;
  closeCommandBuilder: () => void;
  setActiveTab: (tab: Tab) => void;
  setTableFilter: (f: TableFilter) => void;
}

export const useStore = create<AppState>((set) => ({
  data: null,
  fileName: null,
  loadError: null,
  showCommandBuilder: false,
  activeTab: 'tree',
  tableFilter: TABLE_FILTER_ALL,
  setData: (data, fileName) =>
    set({
      data,
      fileName,
      loadError: null,
      activeTab: 'tree',
      tableFilter: TABLE_FILTER_ALL,
    }),
  setError: (msg) => set({ loadError: msg }),
  clear: () => set({ data: null, fileName: null, loadError: null }),
  openCommandBuilder: () => set({ showCommandBuilder: true }),
  closeCommandBuilder: () => set({ showCommandBuilder: false }),
  setActiveTab: (tab) => set({ activeTab: tab }),
  setTableFilter: (f) => set({ tableFilter: f }),
}));
